import { CONTEST_TYPES } from '../data/contestTypes';
import { LESSON_TYPES } from '../data/lessonTypes';
import { LESSON_INPUT_OPTIONS } from '../data/lessonInputOptions';

export default function lessonInputPlaceholder(lessonType, contestType) {
  const label = LESSON_INPUT_OPTIONS[lessonType].label;

  if (
    lessonType === LESSON_TYPES.contest &&
    contestType === CONTEST_TYPES.group
  ) {
    return 'Group Contest ID';
  } else if (lessonType === LESSON_TYPES.contest) {
    return 'Single Contest ID';
  } else {
    return `${label} Slug Id`;
  }
}
